export default __webpack_public_path__ + "static/media/rakuten_preview.0a5090ef.png";